import * as yup from 'yup'

export const FormReadjustmentSchema = yup.object({
  amount: yup.number().required('Valor obrigatório.')
})
